module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "FBMHD"
  }, [_c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/int.htm"
    }
  }, [_vm._v("Introduction…")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("Tools & Equipment")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("Cake Recipes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm#c2"
    }
  }, [_vm._v("Vanilla")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm#c3"
    }
  }, [_vm._v("Chocolate")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm#c4"
    }
  }, [_vm._v("Vanilla Buttercream")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm#c5"
    }
  }, [_vm._v("Chocolate Buttercream")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("Techniques")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm#c6"
    }
  }, [_vm._v("Making Push Pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm#c7"
    }
  }, [_vm._v("Colouring")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm#c8"
    }
  }, [_vm._v("Decorating")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("Sensational Seasons")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm#c9"
    }
  }, [_vm._v("Snowflake Wishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("Christmas Pudding")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("Pumpkin Patch")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("Bump in the Night")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("Down the Rabbit Hole")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("Bunny Ears")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("4th of July")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("Hey Little Pilgrim")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("Lovehearts")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("Sealed with a Kiss")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-CH-SUB"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("New Year’s Rockin’ Eve")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("Suppliers")])])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-CH-T"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ata.htm"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ef1ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0